import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observer } from 'mobx-react'
import { observable } from 'mobx'

import Button from '../../shared/components/Button'
import StepNav from '../../shared/components/StepNav'
import Stepper from '../../shared/components/Stepper'
import ProgramDetails from '../../frontend/program/components/Details'
import Form from './Form'
import { isNotEmpty } from '../../shared/utils'
import Preview from '../../shared/components/Preview'

@observer
class FormPage extends Component {

  static defaultProps = {
    current: {}
  }

  static numberFields = [
    'generalPrice', 'minPrice', 'costsByPerson', 'materialCosts'
  ]

  static propTypes = {
    canDelete: PropTypes.bool,
    current: PropTypes.object,
    id: PropTypes.number,
    isBusy: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props: Object) {
    super(props)
    this.state = {
      section: 'general',
      // eslint-disable-next-line
      formData: {}
    }
  }

  @observable showPreview = false

  @autobind
  handleChange({ target }) {
    const { checked, type, value } = target
    let { name } = target

    let formData = type === 'checkbox'
      ? { [name]: checked }
      : { [name]: value }

    if (name === 'images') {
      value.forEach((image) => {
        image.pivot = image.pivot || {}
        image.pivot.type = image.type
        image.pivot.description = image.description
        image.banner = image.type === 'banner'
      })
    }

    if (
      (name === 'temporarilyNotBookable')
    ) {
      if (!checked) {
        formData.temporarilyNotBookableReason = ''
      }
      else if (!isNotEmpty(formData.temporarilyNotBookableReason)) {
        formData.temporarilyNotBookableReason = 'Coronabedingt momentan nicht buchbar'
      }
    }

    if (
      (name === 'minPrice' && isNotEmpty(value))
      || (name === 'costsByPerson' && isNotEmpty(value))
    ) {
      formData.generalPrice = ''
    }

    if (name === 'generalPrice' && isNotEmpty(value)) {
      formData.minPrice = ''
      formData.costsByPerson = ''
    }

    if (name.indexOf('.') !== -1) {
      const parts = name.split('.')
      name = parts.pop()
      const obj = {}
      const parent = parts.reduce((memo, part) => {
        memo[part] = {}
        return memo[part]
      }, obj)
      parent[name] = value
      formData = obj
    }

    this.props.current.set(formData)
  }

  @autobind
  handleSectionChange({ target }) {
    this.setState({ section: target.value })
  }

  @autobind
  handleDelete(e) {
    e.preventDefault()
    if (this.props.onDelete) {
      this.props.onDelete(this.props.current)
    }
  }

  @autobind
  handleActivate(e) {
    e.preventDefault()
    if (this.props.onActivate) {
      this.props.onActivate(this.props.current)
    }
  }

  @autobind
  handleCancel(e) {
    e.preventDefault()
    if (this.props.onClose) {
      this.props.onClose(this.props.current)
    }
  }

  @autobind
  handleSave(e) {
    e.preventDefault()
    if (this.props.onSave) {
      this.props.onSave(this.props.current)
    }
  }

  @autobind
  handleTogglePreview(e) {
    e.preventDefault()
    this.showPreview = !this.showPreview
  }

  museumIsDeactivated() {
    if (this.props.current.museum) {
      return !!this.props.current.museum.isDeactivated
    }
    return false
  }

  render() {

    const { current, canDelete } = this.props
    const { section } = this.state
    // const validationObj = this.isValid()

    const steps = [
      { key: 'general', title: '1. Allgemein' },
      { key: 'reference', title: '2. Bezug' },
      { key: 'booking', title: '3. Buchung & Kosten' },
      { key: 'material', title: '4. Materialien' },
      { key: 'media', title: '5. Medien' },
      { key: 'overview', title: '6. Übersicht' },
    ]

    return (
      <div className="program vertical">

        <Preview
          showPreview={this.showPreview}
          onTogglePreview={this.handleTogglePreview}
          previewComponent={ProgramDetails}
          previewProps={{
            program: current || {},
            params: { id: current ? current.id || '-1' : '-1' },
          }}
          disabled={!current.isValid}
        />

        <form
          className="form form-horizontal vertical"
          onSubmit={this.handleSave}
        >

          <h1>Programmdaten</h1>

          <StepNav
            active={section}
            onChange={this.handleSectionChange}
            steps={steps}
          />

          {current.isDeactivated
            ? (
              <div className="text-center help-block">
                Dieses Programm ist deaktiviert. Änderungen können erst durchgeführt werden
                nachdem es reaktiviert wurde.
              </div>
            )
            : null}

          <Form
            section={this.state.section}
            current={current}
            validationObj={current.validFields}
            onChange={this.handleChange}
            goToSection={this.handleSectionChange}
            steps={steps}
            readOnly={current.isDeactivated}
          />

          <Stepper
            active={section}
            onChange={this.handleSectionChange}
            steps={steps}
          />

          <div className="form-group">

            <Button
              className="btn btn-default"
              type="button"
              onClick={this.handleCancel}
            >
              Abbrechen
            </Button>

            <Button
              className="action btn btn-danger pull-left"
              type="button"
              onClick={this.handleDelete}
              disabled={!current.id}
              icon="trash"
              busy={this.props.isBusy}
              confirmation={canDelete
                ? 'Dieses Programm wirklich löschen?'
                : 'Dieses Programm wirklich deaktivieren?'}
            >
              {canDelete ? 'Löschen' : 'Deaktivieren'}
            </Button>

            {current.isDeactivated
              ? (
                <Button
                  className="btn action btn-primary pull-right"
                  type="submit"
                  onClick={this.handleActivate}
                  disabled={!current.id || this.museumIsDeactivated()}
                  busy={this.props.isBusy}
                  icon="ok"
                  confirmation="Dieses Programm wirklich reaktivieren?"
                >
                  Aktivieren
                </Button>
              )
              : (
                <Button
                  className="action btn btn-primary pull-right"
                  type="submit"
                  onClick={this.handleSave}
                  disabled={!current.isValid || this.museumIsDeactivated()}
                  icon="ok"
                  busy={this.props.isBusy}
                >
                  Speichern
                </Button>
              )}

            <Button
              className="btn btn-default pull-right"
              onClick={this.handleTogglePreview}
              disabled={!current.isValid}
              title={current.isValid ? null : 'Vorschau erst möglich, wenn alle Fehler beseitigt wurden'}
            >
              Vorschau
            </Button>

            {this.museumIsDeactivated() ? (
              <div className="help-block pull-right">
                Das Museum ist deaktiviert, deshalb sind zur Zeit keine Änderungen
                am Programm möglich.&nbsp;
              </div>
            ) : null}

          </div>

        </form>
      </div>
    )
  }
}

export { FormPage as default }



// WEBPACK FOOTER //
// ./src/program/components/FormPage.js